module.exports = __webpack_public_path__ + "static/media/1-10.6601c806.mp3";